<template>
  <p>
    {{ text }}
  </p>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 0.875rem;
  color: #202223;
}
</style>
